function AppHeading() {
  return (
    <h1 className="text-6xl text-center font-bold lg:text-normal lg:text-7xl">
      <span className="text-primary-cta">3on3</span> Social
    </h1>
  );
}

export { AppHeading };
